import { render, staticRenderFns } from "./SideDrawerSettings.vue?vue&type=template&id=58945b99&"
import script from "./SideDrawerSettings.vue?vue&type=script&lang=js&"
export * from "./SideDrawerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports